import { render, staticRenderFns } from "./SinPermisosView.vue?vue&type=template&id=90bee3c8&scoped=true"
import script from "./SinPermisosView.vue?vue&type=script&lang=js"
export * from "./SinPermisosView.vue?vue&type=script&lang=js"
import style0 from "./SinPermisosView.vue?vue&type=style&index=0&id=90bee3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bee3c8",
  null
  
)

export default component.exports